"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PeriodDaysComponent = void 0;
const React = __importStar(require("react"));
const react_1 = require("react");
const antd_1 = require("antd");
const icons_1 = require("@ant-design/icons");
const lodash_1 = __importDefault(require("lodash"));
const PeriodDaysComponent = (props) => {
    const onClickMenu = ({ key }) => {
        props.onChange(key);
    };
    const renderInputLabel = () => {
        if (props.value === 30) {
            return "Last month";
        }
        if (props.value === 365) {
            return "Last year";
        }
        if (props.value === 730) {
            return "Last 2 years";
        }
        return `Last ${props.value} days`;
    };
    const items = (0, react_1.useMemo)(() => {
        const additional = [];
        const longPeriods = props.only30_60_90 === true ? [] : [
            { key: "180", label: "Last 180 days" },
            { key: "365", label: "Last year" },
            { key: "730", label: "Last 2 years" },
        ];
        return lodash_1.default.compact(lodash_1.default.concat(additional, [
            { key: "30", label: "Last 30 days" },
            { key: "60", label: "Last 60 days" },
            { key: "90", label: "Last 90 days" },
        ], longPeriods));
    }, [props.only30_60_90]);
    const renderMenu = () => {
        return React.createElement(antd_1.Menu, { onClick: onClickMenu, items: items });
    };
    return React.createElement(antd_1.Form.Item, null,
        React.createElement(antd_1.Dropdown, { overlay: renderMenu, trigger: ["click"], disabled: false },
            React.createElement(antd_1.Button, null,
                renderInputLabel(),
                " ",
                React.createElement(icons_1.DownOutlined, null))));
};
exports.PeriodDaysComponent = PeriodDaysComponent;
